module.exports = __webpack_public_path__ + "static/media/workPvcCeilings21.d035a409.jpg";